import React from "react";
import KeyDescription from "./KeyDescription";
import { Container } from "./styles";

function ResultsKey() {
  return (
    <Container>
      <KeyDescription />
    </Container>
  );
}

export default ResultsKey;
